import React, { useState, useEffect } from 'react';
import './courseDetailsTopicCard.css'
import { Link } from 'react-scroll';
import { useDispatch } from 'react-redux';
import { setActiveObj, setPopUpFlag } from '../../../C2wStore/actions';
import { useParams } from 'react-router';
// import courseDetailData from '/data/coursesDetails.json'

function C2wCourseDetailsTopicCard({ obj = null, i=null, selectedIndex=null}) {
    const [videoLinks, setVideoLinks] = useState()
    const courseId = useParams()

    /**
 * @constant windowWidth, setWindowWidth
 * @author Vishal Lohbande
 *
 * Description:
 * - Tracks the current width of the browser window using React state.
 * - Initializes `windowWidth` with the current value of `window.innerWidth`.
 * - Sets up an event listener on the `resize` event to update the `windowWidth` state whenever the browser is resized.
 * - Cleans up the event listener on component unmount to avoid memory leaks.
 *
 * Usage:
 * - Useful for implementing responsive UI behavior based on browser width.
 * - Can be used to conditionally render or style components depending on the screen size.
 *
 * Notes:
 * - `useEffect` is called once on component mount due to the empty dependency array `[]`.
 * - State updates via `setWindowWidth` are triggered every time the window is resized.
 */
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    /**
 * @hook useEffect
 * @author Vishal Lohbande
 * @Date 27-05-2025
 *
 * useEffect - Fetches and sets the details of a specific course based on `courseId.id`.
 *
 * Behavior:
 * - Triggers whenever `courseId.id` changes.
 * - Sends a fetch request to `/data/coursesDetails.json`.
 * - Parses the response as JSON.
 * - Searches for a course object in the `courses` array whose `id` matches `courseId.id`.
 * - Updates the state `courseData` with the matched course object.
 * - Extracts the `videoLinkArray` from the course's `courseVideoContent` and updates `videoLinks` state.
 * - Logs an error to the console if the fetch fails or parsing encounters an issue.
 *
 * Usage Scenario:
 * - Useful in a course detail page where the content changes dynamically based on the selected course.
 * - Supports routing or dynamic loading of individual course data based on route parameters or user selection.
 *
 * Notes:
 * - Make sure `courseId.id` is available and correctly parsed (e.g., from route params).
 * - Ensure the `coursesDetails.json` file is located correctly within the public directory (`public/data/`).
 * - `parseInt(courseId?.id)` ensures type matching with numeric course IDs.
 */
      const [courseData, setCourseData] = useState(null);
      useEffect(() => {
        fetch("/data/coursesDetails.json")
          .then((res) => res.json())
          .then((data) => {
            const course = data?.courses?.find(course => course?.id === parseInt(courseId?.id));
            setCourseData(course);
            setVideoLinks(course?.courseVideoContent?.videoLinkArray)

          })
          .catch((err) => {
          });
      }, [courseId?.id]);


    const svgArr = [
        (<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M26.25 17.5H25V5H26.25C26.5815 5 26.8995 4.8683 27.1339 4.63388C27.3683 4.39946 27.5 4.08152 27.5 3.75C27.5 3.41848 27.3683 3.10054 27.1339 2.86612C26.8995 2.6317 26.5815 2.5 26.25 2.5H3.75C3.41848 2.5 3.10054 2.6317 2.86612 2.86612C2.6317 3.10054 2.5 3.41848 2.5 3.75C2.5 4.08152 2.6317 4.39946 2.86612 4.63388C3.10054 4.8683 3.41848 5 3.75 5H5V17.5H3.75C3.41848 17.5 3.10054 17.6317 2.86612 17.8661C2.6317 18.1005 2.5 18.4185 2.5 18.75C2.5 19.0815 2.6317 19.3995 2.86612 19.6339C3.10054 19.8683 3.41848 20 3.75 20H13.75V21.4375L8.0625 25.1875C7.82917 25.3319 7.64985 25.5491 7.55221 25.8056C7.45457 26.0621 7.44404 26.3435 7.52224 26.6066C7.60044 26.8696 7.76303 27.0996 7.98492 27.2611C8.2068 27.4225 8.47566 27.5065 8.75 27.5C8.99575 27.5028 9.2362 27.4285 9.4375 27.2875L13.75 24.4375V26.25C13.75 26.5815 13.8817 26.8995 14.1161 27.1339C14.3505 27.3683 14.6685 27.5 15 27.5C15.3315 27.5 15.6495 27.3683 15.8839 27.1339C16.1183 26.8995 16.25 26.5815 16.25 26.25V24.4375L20.5625 27.2875C20.7638 27.4285 21.0042 27.5028 21.25 27.5C21.5171 27.4979 21.7764 27.4104 21.9901 27.2502C22.2038 27.09 22.3606 26.8656 22.4375 26.6098C22.5143 26.3541 22.5073 26.0804 22.4173 25.8289C22.3273 25.5775 22.1592 25.3614 21.9375 25.2125L16.25 21.4625V20H26.25C26.5815 20 26.8995 19.8683 27.1339 19.6339C27.3683 19.3995 27.5 19.0815 27.5 18.75C27.5 18.4185 27.3683 18.1005 27.1339 17.8661C26.8995 17.6317 26.5815 17.5 26.25 17.5ZM22.5 17.5H7.5V5H22.5V17.5ZM12.0125 15.325C12.3457 15.5218 12.7255 15.6257 13.1125 15.6257C13.4995 15.6257 13.8793 15.5218 14.2125 15.325L17.9625 13.15C18.2831 12.9532 18.5479 12.6776 18.7316 12.3493C18.9152 12.021 19.0117 11.6512 19.0117 11.275C19.0117 10.8988 18.9152 10.529 18.7316 10.2007C18.5479 9.87245 18.2831 9.59677 17.9625 9.4L14.2125 7.225C13.8793 7.02816 13.4995 6.92433 13.1125 6.92433C12.7255 6.92433 12.3457 7.02816 12.0125 7.225C11.6768 7.41425 11.3985 7.69074 11.207 8.02521C11.0156 8.35968 10.9182 8.73968 10.925 9.125V13.475C10.9271 13.8519 11.0288 14.2215 11.2198 14.5464C11.4107 14.8713 11.6842 15.1399 12.0125 15.325ZM13.425 9.6L16.25 11.25L13.4 12.9L13.425 9.6Z" fill="white" />
        </svg>

        ),
        (<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27.7091 3.30511C26.7938 3.14746 25.867 3.06631 24.9383 3.06251C21.7695 3.05991 18.6669 3.96855 16.0001 5.68011C13.3265 3.99102 10.2243 3.10468 7.06194 3.12635C6.1332 3.13016 5.20638 3.2113 4.29111 3.36896C3.99131 3.42064 3.71981 3.57767 3.52551 3.81177C3.33121 4.04587 3.22687 4.34164 3.2313 4.64584V19.9684C3.22856 20.156 3.26721 20.342 3.34449 20.5129C3.42177 20.6839 3.53579 20.8358 3.67843 20.9577C3.82106 21.0796 3.98882 21.1686 4.16975 21.2183C4.35068 21.268 4.54035 21.2772 4.72525 21.2453C6.55505 20.9285 8.42974 20.9811 10.2389 21.3999C12.0481 21.8188 13.7551 22.5954 15.2595 23.6841L15.4127 23.7735H15.5532C15.6948 23.8325 15.8467 23.8629 16.0001 23.8629C16.1535 23.8629 16.3054 23.8325 16.447 23.7735H16.5875L16.7407 23.6841C18.2346 22.5711 19.9368 21.7693 21.7463 21.3262C23.5558 20.8831 25.4358 20.8079 27.275 21.1048C27.4599 21.1368 27.6495 21.1275 27.8305 21.0778C28.0114 21.0281 28.1792 20.9391 28.3218 20.8172C28.4644 20.6953 28.5785 20.5435 28.6557 20.3725C28.733 20.2015 28.7717 20.0156 28.7689 19.828V4.50538C28.7556 4.21445 28.6433 3.9368 28.4505 3.71849C28.2578 3.50018 27.9962 3.35432 27.7091 3.30511ZM14.7232 20.2749C12.3609 19.0321 9.73129 18.3834 7.06194 18.3851C6.64057 18.3851 6.2192 18.3851 5.78506 18.3851V5.61627C6.21034 5.59176 6.63667 5.59176 7.06194 5.61627C9.78602 5.61326 12.4507 6.41265 14.7232 7.91466V20.2749ZM26.2152 18.4362C25.781 18.4362 25.3597 18.4362 24.9383 18.4362C22.2689 18.4345 19.6394 19.0831 17.277 20.3259V7.91466C19.5496 6.41265 22.2142 5.61326 24.9383 5.61627C25.3636 5.59176 25.7899 5.59176 26.2152 5.61627V18.4362ZM27.7091 23.7352C26.7938 23.5776 25.867 23.4964 24.9383 23.4926C21.7695 23.49 18.6669 24.3987 16.0001 26.1102C13.3334 24.3987 10.2307 23.49 7.06194 23.4926C6.1332 23.4964 5.20638 23.5776 4.29111 23.7352C4.12489 23.7616 3.96553 23.8206 3.82219 23.9088C3.67885 23.9969 3.55435 24.1126 3.45586 24.249C3.35737 24.3855 3.28682 24.5401 3.24828 24.7039C3.20975 24.8677 3.20397 25.0376 3.2313 25.2036C3.29619 25.5352 3.48985 25.8276 3.76987 26.0166C4.04989 26.2057 4.39344 26.2761 4.72525 26.2124C6.55505 25.8956 8.42974 25.9481 10.2389 26.367C12.0481 26.7858 13.7551 27.5625 15.2595 28.6512C15.4758 28.8052 15.7346 28.8879 16.0001 28.8879C16.2656 28.8879 16.5245 28.8052 16.7407 28.6512C18.2451 27.5625 19.9522 26.7858 21.7613 26.367C23.5705 25.9481 25.4452 25.8956 27.275 26.2124C27.6068 26.2761 27.9503 26.2057 28.2304 26.0166C28.5104 25.8276 28.704 25.5352 28.7689 25.2036C28.7963 25.0376 28.7905 24.8677 28.7519 24.7039C28.7134 24.5401 28.6429 24.3855 28.5444 24.249C28.4459 24.1126 28.3214 23.9969 28.178 23.9088C28.0347 23.8206 27.8753 23.7616 27.7091 23.7352Z" fill="white" />
        </svg>

        ),
        (
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 8.75C5 8.05964 4.44036 7.5 3.75 7.5C3.05964 7.5 2.5 8.05964 2.5 8.75V25C2.5 26.375 3.625 27.5 5 27.5H21.25C21.9404 27.5 22.5 26.9404 22.5 26.25C22.5 25.5596 21.9404 25 21.25 25H5V8.75ZM25 2.5H10C8.625 2.5 7.5 3.625 7.5 5V20C7.5 21.375 8.625 22.5 10 22.5H25C26.375 22.5 27.5 21.375 27.5 20V5C27.5 3.625 26.375 2.5 25 2.5ZM25 20H10V5H25V20ZM16.8875 12.7C17.4 11.7875 18.3625 11.25 18.925 10.45C19.525 9.6 19.1875 8.025 17.5 8.025C16.4 8.025 15.85 8.8625 15.625 9.5625L13.9125 8.85C14.3875 7.45 15.65 6.25 17.4875 6.25C19.025 6.25 20.0875 6.95 20.625 7.825C21.0875 8.575 21.35 9.9875 20.6375 11.0375C19.85 12.2 19.1 12.55 18.6875 13.3C18.525 13.6 18.4625 13.8 18.4625 14.775H16.5625C16.575 14.2625 16.4875 13.425 16.8875 12.7ZM16.1875 17.4375C16.1875 16.7 16.775 16.1375 17.5 16.1375C18.2375 16.1375 18.8 16.7 18.8 17.4375C18.8 18.1625 18.25 18.75 17.5 18.75C16.775 18.75 16.1875 18.1625 16.1875 17.4375Z" fill="white" />
            </svg>

        )
    ]


     /** 
 * @description
 * This hook retrieves video links for a specific course from `courseDetailData`
 * and updates the state using `setVideoLinks` when the component mounts.
 * 
 * @dependencies
 * - `useEffect`: Executes on mount.
 * - `useDispatch`: Allows Redux actions dispatching if needed.
 * 
 * @notes
 * Ensure `courseDetailData.courses` contains valid data. Handle cases where
 * no matching course is found to avoid errors.
 * @author govind dindewad
 */
const dispatch = useDispatch();

    return (        
        <Link
        className='C2wCourseDetailsTopicCard_ctn_link'
        to={ obj?.videoSrc !== null ? 'section2' : null}  // scroll to video player section
            smooth={true} 
            duration={500}
            offset={-160}
            onClick={()=>{
                if(obj?.videoSrc === null){
                    dispatch(setPopUpFlag(true));  // to close popup
                    return
                }
                dispatch(setActiveObj({videoSrc : obj?.videoSrc, thumbnail: null})) // for set video to player 
            }}
            containerId='C2wCourseDetailsContainer'
        ><div className='C2wCourseDetailsTopicCard_ctn'>
            <div className='C2wCourseDetailsTopicCard_left'>
                <div className='C2wSvg_hld' style={{background: obj?.type === 0 ? 'rgba(22, 117, 242, 1)' : obj?.type === 1 ?   'rgba(252, 174, 16, 1)' : 'rgba(26, 159, 101, 1)' }}>
                    {svgArr[obj?.type]}
                </div>
                <div className='C2wTopicDetailTitle'>
                    {obj?.title}
                    { windowWidth > 620 ? obj?.videoSrc !== null && obj?.type === 0 ? <span>{"free trial"}</span> : null : null }
                </div>
            </div>
            <div className='C2wCourseDetailsTopicCard_right'>
                { windowWidth <= 620 ? obj?.videoSrc !== null && obj?.type === 0 ? <span className='C2wFreeTrialAbsolute'>{"free trial"}</span> : null : null }
                {obj?.descContent}{obj?.type === 0 ? null : obj?.type === 1 ? ' Marks' : ' MCQs' }
                {obj?.type === 0 &&
                    <svg className='VideoIcon' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="15" cy="15" r="15" fill="white" fill-opacity="0.2" />
                        <path d="M11.333 9.88908C11.333 9.36164 11.9165 9.04307 12.3602 9.32829L20.1273 14.3215C20.5356 14.5839 20.5356 15.1806 20.1273 15.443L12.3602 20.4362C11.9165 20.7214 11.333 20.4029 11.333 19.8754V9.88908Z" fill="white" />
                    </svg>
                }
            </div>
        </div>
        </Link>
    
    )
}

export default C2wCourseDetailsTopicCard
